var LayerPosition;
(function (LayerPosition) {
    LayerPosition["top"] = "top";
    LayerPosition["right"] = "right";
    LayerPosition["bottom"] = "bottom";
    LayerPosition["left"] = "left";
})(LayerPosition || (LayerPosition = {}));

export { LayerPosition };
